import moment from "moment"

export const applyFilterList = (data, filter, tagsToFilter) => {
  let filteredUsers = data || []

  const searchTerm = filter?.search && `${filter?.search}`.trim()

  const formatCity = (user) => ({
    ...user,
    city: user.city === null ? "Não cadastrada" : user.city,
  })

  filteredUsers = filteredUsers.map(formatCity)

  if (filter.ids && filter.ids.trim()) {
    const idValues = filter.ids.split(" ").filter((item) => item)
    filteredUsers = filteredUsers.filter((item) =>
      idValues.some(
        (value) =>
          getItensOnFilter(item?.email, value) ||
          getItensOnFilter(item?.name, value) ||
          getItensOnFilter(item?.phone, value),
      ),
    )
  }

  if (filter.tags && filter.tags.length) {
    const isSemTag = filter.tags === "Sem tag"
    filteredUsers = filteredUsers.filter((user) => {
      const filteredTagItems = user.tag_user?.filter((item) =>
        isSemTag ? item?.tag?.id === null : item?.name === filter.tags,
      )
      return filteredTagItems.length > 0
    })
  }

  if (searchTerm && searchTerm !== "") {
    filteredUsers = filteredUsers.filter((card) => filterBySearch(card, searchTerm))
  }

  if (filter?.city) {
    filteredUsers = filteredUsers.filter((card) => filterByCity(card, filter))
  }

  if (filter?.tag?.length) {
    filteredUsers = filteredUsers.filter((card) => filterByTag(card, filter, tagsToFilter))
  }

  if (filter?.tagException?.length) {
    filteredUsers = filteredUsers.filter((card) => filterByTagException(card, filter))
  }

  if (filter?.activityTime) {
    filteredUsers = filteredUsers.filter((card) => filterByActivityTime(card, filter))
  }

  if (filter.producersByForm) {
    if (filter.producersByForm.length) {
      const allCodes = [...new Set(filter.producersByForm.map(row => row.code))];

      if (filter.producersWithoutDW?.value) { // with empty answers
        filteredUsers = filteredUsers.filter(producer => {
          let hasValidAnswer = false;
          
          allCodes.map(code => {
            if(code && !hasValidAnswer) {
              const allAnswerByCode = filter.producersByForm.filter(row => row.id === producer.id);
              hasValidAnswer = allAnswerByCode.filter(item => item.value && item.value !== '∅').length ? true : false;
            }
          })

          return !hasValidAnswer;
        });

      } else {
        filteredUsers = filteredUsers.filter(producer => {
          let hasValidAnswer = false;

          allCodes.map(code => {
            if(code && !hasValidAnswer) {
              const allAnswerByCode = filter.producersByForm.filter(row => row.id === producer.id);
              hasValidAnswer = allAnswerByCode.filter(item => item.value && item.value !== '∅').length ? true : false;
            }
          })

          return hasValidAnswer;
        });
      }
    } else {
      filteredUsers = []
    }
  }

  return filteredUsers
}

export const applyFilterKanban = (data, filter, tagsToFilter) => {
  const searchTerm = filter?.search && `${filter?.search}`.trim()

  const transformCard = (card) => {
    const updatedCard = { ...card }
    if (updatedCard.city === null) {
      updatedCard.city = "Não cadastrada"
    }
    return updatedCard
  }

  const applyFilterToLane = (lane) => {
    let filteredCards = lane.cards.map(transformCard)

    if (searchTerm && searchTerm !== "") {
      filteredCards = filteredCards.filter((card) => filterBySearch(card, searchTerm))
    }

    if (filter?.city) {
      filteredCards = filteredCards.filter((card) => filterByCity(card, filter))
    }

    if (filter?.tag?.length) {
      filteredCards = filteredCards.filter((card) => filterByTag(card, filter, tagsToFilter))
    }

    if (filter?.tagException?.length) {
      filteredCards = filteredCards.filter((card) => filterByTagException(card, filter))
    }

    if (filter?.activityTime) {
      filteredCards = filteredCards.filter((card) => filterByActivityTime(card, filter))
    }

    if (filter?.date) {
      filteredCards = filteredCards.filter((card) => filterByTagAssignmentDate(card, filter))
    }

    if (filter.producersByForm) {
      if (filter.producersByForm.length) {
        const allCodes = [...new Set(filter.producersByForm.map(row => row.code))];
  
        if (filter.producersWithoutDW?.value) { // with empty answers
          filteredCards = filteredCards.filter(producer => {
            let hasValidAnswer = false;
            
            allCodes.map(code => {
              if(code && !hasValidAnswer) {
                const allAnswerByCode = filter.producersByForm.filter(row => row.id === producer.id);
                hasValidAnswer = allAnswerByCode.filter(item => item.value && item.value !== '∅').length ? true : false;
              }
            })
  
            return !hasValidAnswer;
          });
  
        } else {
          filteredCards = filteredCards.filter(producer => {
            let hasValidAnswer = false;
  
            allCodes.map(code => {
              if(code && !hasValidAnswer) {
                const allAnswerByCode = filter.producersByForm.filter(row => row.id === producer.id);
                hasValidAnswer = allAnswerByCode.filter(item => item.value && item.value !== '∅').length ? true : false;
              }
            })
  
            return hasValidAnswer;
          });
        }
      } else {
        filteredCards = []
      }
    }
  

    return {
      ...lane,
      cards: filteredCards,
      label: filteredCards.length,
    }
  }

  const filteredLanes = data && data.lanes && data.lanes.map(applyFilterToLane)

  return { lanes: filteredLanes || [] }
}

export const applyFilterEsm = (data, dataHistory, valuesSearch, filter) => {
  let filteredUsers = data || []
  let filteredHistory = dataHistory

  if(filter.projects && filter.projects.length) {
    filteredUsers = filteredUsers.filter((item) => filter.projects.find(row => row.value === item.projectId))
    filteredHistory = filteredHistory.filter((item) => filter.projects.find(row => row.value === item.projectId))
  }

  if (filter.search && filter.search.trim()) {
    const searchTerm = filter.search.toLowerCase().trim()
    filteredUsers = filteredUsers.filter((item) => {
      return (
        getItensOnFilter(item?.email, searchTerm) ||
        getItensOnFilter(item?.label, searchTerm) ||
        getItensOnFilter(item?.conceito, searchTerm)
      )
    })

    filteredHistory = filteredHistory.filter((item) => {
      return getItensOnFilter(item?.user?.name, searchTerm)
      // getItensOnFilter(item?.name, searchTerm) ||
      // getItensOnFilter(item?.email, searchTerm)
    })
  }

  if (filter.city && filter.city?.value) {
    const cityLabel = filter.city?.label?.toLowerCase()

    filteredUsers = filteredUsers.filter((item) => getItensOnFilter(item?.city, cityLabel))
    filteredHistory = filteredHistory.filter((item) => getItensOnFilter(item?.city, cityLabel))
  }

  
  if (valuesSearch) {
    if (valuesSearch?.data) {
      filteredUsers = filteredUsers.filter((item) =>
        valuesSearch.data.some((prod) => prod.userId === item?.item?.userId),
      )
      filteredHistory = filteredHistory.filter((item) =>
        valuesSearch.data.some((prod) => prod.userId === item?.item?.userId),
      )
    }
  }

  return { filteredUsers, filteredHistory }
}

const getItensOnFilter = (item, filter) => {
  return item?.toLowerCase().includes(filter?.toLowerCase())
}

const filterByTagAssignmentDate = (item, filter) => {
  return item?.generalTag && filter?.date && moment(item.generalTag?.assignmentDate).format("DD/MM/YYYY") === moment(filter.date).format("DD/MM/YYYY")
}

const filterBySearch = (data, searchTerm) => {
  return getItensOnFilter(data?.email, searchTerm) || getItensOnFilter(data?.name, searchTerm) || getItensOnFilter(data?.phone, searchTerm)
}

const filterByCity = (data, filter) => getItensOnFilter(data?.city, filter.city?.label)

const filterByTag = (data, filter, tagsToFilter) => {
  if (!data?.tag_user || !data.tag_user.length) {
    return false;
  }

  const allUserTagIds = data.tag_user?.map((tag) => tag?.name || tag?.title)
  const tags = filter?.tag?.map((tag) => tag?.label)

  const matchTags = (item) => tags.some((tag) => tag.includes(item));

  const filteredTags = tagsToFilter
    ? allUserTagIds.filter(matchTags)
    : allUserTagIds.filter((item) => tags.indexOf(item) !== -1);

  return !tagsToFilter
    ? filteredTags.length === tags.length
    : filteredTags.length > 0;
}

const filterByTagException = (data, filter) => {

  const allUserTagIds = data.tag_user?.map((tag) => tag?.name || tag?.title)
  const tags = filter?.tagException?.map((tag) => tag?.label)

  const matchTags = (item) => tags.some((tag) => tag.includes(item));

  const filteredTags = allUserTagIds.filter(matchTags)

  return !filteredTags.length;
}

const filterByActivityTime = (data, filter) => {
  if (filter.activityTime.label === "+ 30 dias") {
    return (
      data.lastAcitvity?.activity !== 0 &&
      (data.lastAcitvity?.activity?.includes("meses") ||
        data.lastAcitvity?.activity?.includes("ano") ||
        data.lastAcitvity?.activity?.includes("31 dias") ||
        data.lastAcitvity?.activity?.includes("um mês"))
    )
  } else if (filter.activityTime?.label === "Inativo") {
    return data.lastAcitvity?.status === "Inativo"
  } else {
    const activityTimeLabel = filter.activityTime.label
    return data.lastAcitvity?.activity === activityTimeLabel
  }
}

export const activityOptions = [
  {
    value: "0",
    label: "Ativo",
  },
  {
    value: "1",
    label: "Inativo",
  },
]

export const activityTimeOptions = [
  {
    value: "0",
    label: "há um dia",
  },
  {
    value: "2",
    label: "há 2 dias",
  },
  {
    value: "3",
    label: "há 3 dias",
  },
  {
    value: "4",
    label: "há 4 dias",
  },
  {
    value: "5",
    label: "há 5 dias",
  },
  {
    value: "6",
    label: "há 6 dias",
  },
  {
    value: "7",
    label: "há 7 dias",
  },
  {
    value: "8",
    label: "há 8 dias",
  },
  {
    value: "9",
    label: "há 9 dias",
  },
  {
    value: "10",
    label: "há 10 dias",
  },
  {
    value: "11",
    label: "há 11 dias",
  },
  {
    value: "12",
    label: "há 12 dias",
  },
  {
    value: "13",
    label: "há 13 dias",
  },
  {
    value: "14",
    label: "há 14 dias",
  },
  {
    value: "15",
    label: "há 15 dias",
  },
  {
    value: "16",
    label: "há 16 dias",
  },
  {
    value: "17",
    label: "há 17 dias",
  },
  {
    value: "18",
    label: "há 18 dias",
  },
  {
    value: "19",
    label: "há 19 dias",
  },
  {
    value: "20",
    label: "há 20 dias",
  },
  {
    value: "21",
    label: "há 21 dias",
  },
  {
    value: "22",
    label: "há 22 dias",
  },
  {
    value: "23",
    label: "há 23 dias",
  },
  {
    value: "24",
    label: "há 24 dias",
  },
  {
    value: "25",
    label: "há 25 dias",
  },
  {
    value: "26",
    label: "há 26 dias",
  },
  {
    value: "27",
    label: "há 27 dias",
  },
  {
    value: "28",
    label: "há 28 dias",
  },
  {
    value: "29",
    label: "há 29 dias",
  },
  {
    value: "30",
    label: "há 30 dias",
  },
  {
    value: "31",
    label: "+ 30 dias",
  },
  {
    value: "32",
    label: "Inativo",
  },
]

